{
  "header": {
    "title": "Modèles d'enquête",
    "description": "Parcourez et personnalisez des modèles d'enquête préconçus pour recueillir rapidement des informations pertinentes auprès des employés"
  },
  "tabs": {
    "chirpeeTemplates": "Modèles Chirpee",
    "companyTemplates": "Modèles d’entreprise",
    "myTemplates": "Mes modèles"
  },
  "searchInput": {
    "placeholder": "Rechercher des modèles"
  },
  "sortDropdown": {
    "triggerLabel": "Trier par",
    "options": {
      "questionQuantity": "Nombre de questions",
      "fromNewestToOldest": "Du plus récent au plus ancien",
      "fromOldestToNewest": "Du plus ancien au plus récent"
    }
  }
}
